export default function WorkOrder() {
  return <div>WORK ORDER PAGE</div>;
}
